// extracted by mini-css-extract-plugin
export default {"block":"FilterIfNotBlock_block__KBhWN","text":"FilterIfNotBlock_text__SNskm"};